import { render, staticRenderFns } from "./table-component.vue?vue&type=template&id=9b38f42a&"
import script from "./table-component.vue?vue&type=script&lang=ts&"
export * from "./table-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports